/**
 * These are there different types of roles an agent can have.
 *
 * 'agent' - By default, anyone log into this app has to have this role. This role give him access to some
 *           of the none project related features e.g. Update Profile, List Projects, etc...
 * 'admin' - This is a project specific role which give the agent access to features that are allowed for Admin type of agent
 * 'staff' - This is a project specific role which give the agent access to features that are allowed for Staff type of agent
 */
export var AgentRole;
(function (AgentRole) {
    AgentRole["ADMIN"] = "admin";
    AgentRole["STAFF"] = "staff";
})(AgentRole || (AgentRole = {}));
/**
 * Define all the permission that the app has. Each of these permission should correspond to an endpoint.
 */
export var Permission;
(function (Permission) {
    Permission["PROJECTS_LIST_READ"] = "projects_list_read";
    Permission["PROJECT_DETAILS_READ"] = "project_details_read";
    Permission["PROJECT_DETAILS_WRITE"] = "project_details_write";
    Permission["PROJECT_DETAILS_CREATE"] = "project_details_create";
    Permission["PROJECT_DETAILS_DELETE"] = "project_details_delete";
    Permission["AGENTS_LIST_READ"] = "agents_list_read";
    Permission["AGENT_DETAILS_READ"] = "agent_details_read";
    Permission["AGENT_DETAILS_WRITE"] = "agent_details_write";
    Permission["AGENT_DETAILS_CREATE"] = "agent_details_create";
    Permission["AGENT_DETAILS_DELETE"] = "agent_details_update";
    Permission["AGENTS_LOGS_READ"] = "agent_logs_read";
    Permission["PROJECT_DEVICES_LIST_READ"] = "project_devices_list_read";
    Permission["PROJECT_DEVICE_DETAILS_READ"] = "project_device_details_read";
    Permission["PROJECT_DEVICE_DETAILS_WRITE"] = "project_device_details_write";
    Permission["PROJECT_DEVICE_DETAILS_CREATE"] = "project_device_details_create";
    Permission["PROJECT_DEVICE_DETAILS_DELETE"] = "project_device_details_delete";
    Permission["USER_LIST_READ"] = "users_list_read";
    Permission["USER_DETAILS_READ"] = "user_details_read";
    Permission["USER_DETAILS_WRITE"] = "user_details_write";
    Permission["USER_DETAILS_CREATE"] = "user_details_create";
    Permission["USER_DETAILS_DELETE"] = "user_details_update";
    Permission["HOMES_LIST_READ"] = "homes_list_read";
    Permission["HOME_DETAILS_READ"] = "home_details_read";
    Permission["HOME_DETAILS_WRITE"] = "home_details_write";
    Permission["HOME_DETAILS_CREATE"] = "home_details_create";
    Permission["HOME_DETAILS_DELETE"] = "home_details_update";
    Permission["HOME_MEMBERS_LIST_READ"] = "home_members_list_read";
    Permission["HOME_MEMBER_DETAILS_READ"] = "home_member_details_read";
    Permission["HOME_MEMBER_DETAILS_WRITE"] = "home_member_details_write";
    Permission["HOME_MEMBER_DETAILS_CREATE"] = "home_member_details_create";
    Permission["HOME_MEMBER_DETAILS_DELETE"] = "home_member_details_update";
    Permission["HOME_DEVICES_LIST_READ"] = "home_devices_list_read";
    Permission["HOME_DEVICE_DETAILS_READ"] = "home_device_details_read";
    Permission["HOME_DEVICE_DETAILS_WRITE"] = "home_device_details_write";
    Permission["HOME_DEVICE_DETAILS_CREATE"] = "home_device_details_create";
    Permission["HOME_DEVICE_DETAILS_DELETE"] = "home_device_details_delete";
    Permission["HOME_KV_PAIR_DETAILS_READ"] = "home_kv_pair_details_read";
    Permission["HOME_KV_PAIR_DETAILS_WRITE"] = "home_kv_pair_details_write";
    Permission["HOME_KV_PAIR_DETAILS_CREATE"] = "home_kv_pair_details_create";
    Permission["HOME_KV_PAIR_DETAILS_DELETE"] = "home_kv_pair_details_delete";
    Permission["DEVICE_KV_PAIR_DETAILS_READ"] = "device_kv_pair_details_read";
    Permission["DEVICE_KV_PAIR_DETAILS_WRITE"] = "device_kv_pair_details_write";
    Permission["DEVICE_KV_PAIR_DETAILS_CREATE"] = "device_kv_pair_details_create";
    Permission["DEVICE_KV_PAIR_DETAILS_DELETE"] = "device_kv_pair_details_delete";
    Permission["LOGS_LIST_READ"] = "logs_list_read";
})(Permission || (Permission = {}));
export const RolesAndPermissions = {
    // Permissions that ADMIN agents has
    [AgentRole.ADMIN]: [
        Permission.PROJECTS_LIST_READ,
        Permission.PROJECT_DETAILS_READ,
        Permission.PROJECT_DETAILS_WRITE,
        Permission.AGENTS_LIST_READ,
        Permission.AGENT_DETAILS_READ,
        Permission.AGENT_DETAILS_WRITE,
        Permission.AGENT_DETAILS_CREATE,
        Permission.AGENT_DETAILS_DELETE,
        Permission.AGENTS_LOGS_READ,
        Permission.PROJECT_DEVICES_LIST_READ,
        Permission.PROJECT_DEVICE_DETAILS_READ,
        Permission.PROJECT_DEVICE_DETAILS_WRITE,
        Permission.PROJECT_DEVICE_DETAILS_CREATE,
        Permission.PROJECT_DEVICE_DETAILS_DELETE,
        Permission.USER_LIST_READ,
        Permission.USER_DETAILS_READ,
        Permission.USER_DETAILS_WRITE,
        Permission.USER_DETAILS_CREATE,
        Permission.USER_DETAILS_DELETE,
        Permission.HOMES_LIST_READ,
        Permission.HOME_DETAILS_READ,
        Permission.HOME_DETAILS_WRITE,
        Permission.HOME_DETAILS_CREATE,
        Permission.HOME_DETAILS_DELETE,
        Permission.HOME_KV_PAIR_DETAILS_READ,
        Permission.HOME_KV_PAIR_DETAILS_WRITE,
        Permission.HOME_KV_PAIR_DETAILS_CREATE,
        Permission.HOME_KV_PAIR_DETAILS_DELETE,
        Permission.HOME_MEMBERS_LIST_READ,
        Permission.HOME_MEMBER_DETAILS_READ,
        Permission.HOME_MEMBER_DETAILS_WRITE,
        Permission.HOME_MEMBER_DETAILS_CREATE,
        Permission.HOME_MEMBER_DETAILS_DELETE,
        Permission.HOME_DEVICES_LIST_READ,
        Permission.HOME_DEVICE_DETAILS_READ,
        Permission.HOME_DEVICE_DETAILS_WRITE,
        Permission.HOME_DEVICE_DETAILS_CREATE,
        Permission.HOME_DEVICE_DETAILS_DELETE,
        Permission.DEVICE_KV_PAIR_DETAILS_READ,
        Permission.DEVICE_KV_PAIR_DETAILS_WRITE,
        Permission.DEVICE_KV_PAIR_DETAILS_CREATE,
        Permission.DEVICE_KV_PAIR_DETAILS_DELETE,
        Permission.LOGS_LIST_READ,
    ],
    // Permissions that STAFF agents has
    [AgentRole.STAFF]: [
        Permission.PROJECTS_LIST_READ,
        Permission.PROJECT_DETAILS_READ,
        Permission.AGENTS_LIST_READ,
        Permission.AGENT_DETAILS_READ,
        Permission.PROJECT_DEVICES_LIST_READ,
        Permission.PROJECT_DEVICE_DETAILS_READ,
        Permission.PROJECT_DEVICE_DETAILS_WRITE,
        Permission.PROJECT_DEVICE_DETAILS_CREATE,
        Permission.PROJECT_DEVICE_DETAILS_DELETE,
        Permission.USER_LIST_READ,
        Permission.USER_DETAILS_READ,
        Permission.USER_DETAILS_WRITE,
        Permission.USER_DETAILS_CREATE,
        Permission.USER_DETAILS_DELETE,
        Permission.HOMES_LIST_READ,
        Permission.HOME_DETAILS_READ,
        Permission.HOME_DETAILS_WRITE,
        Permission.HOME_DETAILS_CREATE,
        Permission.HOME_DETAILS_DELETE,
        Permission.HOME_MEMBERS_LIST_READ,
        Permission.HOME_MEMBER_DETAILS_READ,
        Permission.HOME_MEMBER_DETAILS_CREATE,
        Permission.HOME_MEMBER_DETAILS_WRITE,
        Permission.HOME_MEMBER_DETAILS_DELETE,
        Permission.HOME_DEVICES_LIST_READ,
        Permission.HOME_DEVICE_DETAILS_READ,
        Permission.HOME_DEVICE_DETAILS_WRITE,
        Permission.HOME_DEVICE_DETAILS_CREATE,
        Permission.HOME_DEVICE_DETAILS_DELETE,
        Permission.LOGS_LIST_READ,
    ],
};
export var ProjectType;
(function (ProjectType) {
    ProjectType["DEFAULT"] = "";
    ProjectType["SENSOR_CLOUD"] = "sensorCloud";
    ProjectType["MOBILITY_CLOUD"] = "mobilityCloud";
    ProjectType["MEDICAL_CLOUD"] = "medicalCloud";
    ProjectType["ROBOT_CLOUD"] = "robotCloud";
})(ProjectType || (ProjectType = {}));
export var CustomFeature;
(function (CustomFeature) {
    CustomFeature["SENSOR_MODULE"] = "sensor_module";
    CustomFeature["VEHICLE_MAP"] = "vehicle_map";
    CustomFeature["ISSUES"] = "issues";
})(CustomFeature || (CustomFeature = {}));
export const CustomFeaturesByProjectType = {
    [ProjectType.SENSOR_CLOUD]: [
        CustomFeature.SENSOR_MODULE,
    ],
    [ProjectType.MOBILITY_CLOUD]: [
        CustomFeature.VEHICLE_MAP,
    ],
    [ProjectType.MEDICAL_CLOUD]: [],
    [ProjectType.ROBOT_CLOUD]: [
        CustomFeature.ISSUES,
    ],
};
/** ******************************  Below are util functions related to roles and permissions ************************** */
/**
 * Get the list of permissions that an agent has based on his set of roles.
 * An agent can have multiple roles therefore we need to merge all the permissions given to each role. Note that some roles might have
 * the same permissions so we need to make sure we don't return the same permissions multiple times in the result. For example: If an
 * agent has both STAFF and ADMIN roles and both roles have PROJECTS_LIST_READ permission, we only need to return PROJECTS_LIST_READ
 * 1 time in the result.
 *
 * @param roles
 */
const getAgentPermissions = (roles) => {
    // The 'reduce' will build the list of ALL permissions and the feed it into a Set object which will take care of removing duplicates.
    const permissions = new Set(roles.reduce((allPermissions, role) => {
        // Lookup the permissions for the specified 'role' and merge them with the allPermissions array.
        return [...allPermissions, ...(RolesAndPermissions[role] || [])];
    }, []));
    return Array.from(permissions.values());
};
/**
 * Get the set of unique features based on the project type and the set of custom features.
 * We will merge the set of custom features set for the specified project type with the provided set of
 * custom features and return the unique list of custom features.
 */
const getProjectCustomFeatures = (projectType, customFeatures) => {
    const features = new Set([
        ...(projectType ? CustomFeaturesByProjectType[projectType] || [] : []),
        ...customFeatures || [],
    ]);
    return Array.from(features.values());
};
/**
 * Check if the agent is allowed to access the specified page/feature based on his role and his role in the project, if project is provided
 */
const doesAgentHavePermission = (projectAgent, requiredPermissions) => {
    if (projectAgent) {
        if (requiredPermissions && requiredPermissions.length > 0) {
            // Merge the permissions of the agent's roles
            const allPermissions = Array.from(new Set(getAgentPermissions(projectAgent && projectAgent.role ? [projectAgent.role] : [])));
            // Now try to find a requiredPermission that is not in the agent's permissions. If we find 1 then that
            // mean the agent DOES NOT have all the permissions therefore return false.
            return (requiredPermissions.find((requiredPermission) => {
                return !allPermissions.includes(requiredPermission);
            }) === undefined);
        }
        // There is no special permission required, the agent should have access to this resource
        return true;
    }
    // There is no agent, automatically not allowed
    return false;
};
/**
 * Check if the current project has access to the specified page/feature
 */
const canProjectAccessCustomFeature = (project, customFeature) => {
    if (customFeature && customFeature.length > 0) {
        if (project && project.supportToolSettings) {
            const allowedFeatures = getProjectCustomFeatures(project.supportToolSettings.projectType, project.supportToolSettings.customFeatures);
            return allowedFeatures.includes(customFeature);
        }
        // No project selected or project does not have settings, automatically not allowed
        return false;
    }
    // No special permission is required so the agent should be able to access this
    return true;
};
/**
 * Check if the agent has access to the specified page/feature. This will do all the necessary check.
 * If you just need a specific check, use one of the other check instead.
 */
export const hasAccess = (projectAgent, project, requiredPermissions, customFeature) => {
    const hasPermission = doesAgentHavePermission(projectAgent, requiredPermissions);
    const isProjectFeature = canProjectAccessCustomFeature(project, customFeature);
    return hasPermission && isProjectFeature;
};
export const getAgentFeaturePermissions = (agent) => {
    return {
        canViewProject: doesAgentHavePermission(agent, [
            Permission.PROJECT_DETAILS_READ,
        ]),
        canUpdateProject: doesAgentHavePermission(agent, [
            Permission.PROJECT_DETAILS_WRITE,
        ]),
        canViewAgents: doesAgentHavePermission(agent, [
            Permission.AGENTS_LIST_READ,
        ]),
        canAddAgents: doesAgentHavePermission(agent, [
            Permission.AGENT_DETAILS_CREATE,
        ]),
        canRemoveAgents: doesAgentHavePermission(agent, [
            Permission.AGENT_DETAILS_DELETE,
        ]),
        canViewAgentProfile: doesAgentHavePermission(agent, [
            Permission.AGENT_DETAILS_READ,
        ]),
        canUpdateAgentProfile: doesAgentHavePermission(agent, [
            Permission.AGENT_DETAILS_WRITE,
        ]),
        canViewAgentLogs: doesAgentHavePermission(agent, [
            Permission.AGENTS_LOGS_READ,
        ]),
        canViewProjectDevices: doesAgentHavePermission(agent, [
            Permission.PROJECT_DEVICES_LIST_READ,
        ]),
        canViewProjectDeviceDetails: doesAgentHavePermission(agent, [
            Permission.PROJECT_DEVICE_DETAILS_READ,
        ]),
        canUpdateProjectDevice: doesAgentHavePermission(agent, [
            Permission.PROJECT_DEVICE_DETAILS_WRITE,
        ]),
        canCreateProjectDevice: doesAgentHavePermission(agent, [
            Permission.PROJECT_DEVICE_DETAILS_CREATE,
        ]),
        canRemoveProjectDevice: doesAgentHavePermission(agent, [
            Permission.PROJECT_DEVICE_DETAILS_DELETE,
        ]),
        canLookupUsers: doesAgentHavePermission(agent, [
            Permission.USER_LIST_READ,
        ]),
        canViewUserProfile: doesAgentHavePermission(agent, [
            Permission.USER_DETAILS_READ,
        ]),
        canUpdateUserProfile: doesAgentHavePermission(agent, [
            Permission.USER_DETAILS_WRITE,
        ]),
        canCreateUser: doesAgentHavePermission(agent, [
            Permission.USER_DETAILS_CREATE,
        ]),
        canDeleteUser: doesAgentHavePermission(agent, [
            Permission.USER_DETAILS_DELETE,
        ]),
        canViewUserHomes: doesAgentHavePermission(agent, [
            Permission.HOMES_LIST_READ,
        ]),
        canViewUserHomeDetails: doesAgentHavePermission(agent, [
            Permission.HOME_DETAILS_READ,
        ]),
        canUpdateUserHome: doesAgentHavePermission(agent, [
            Permission.HOME_DETAILS_WRITE,
        ]),
        canCreateUserHome: doesAgentHavePermission(agent, [
            Permission.HOME_DETAILS_CREATE,
        ]),
        canRemoveUserHome: doesAgentHavePermission(agent, [
            Permission.HOME_DETAILS_DELETE,
        ]),
        canViewHomeDevices: doesAgentHavePermission(agent, [
            Permission.HOME_DEVICES_LIST_READ,
        ]),
        canViewHomeDeviceDetails: doesAgentHavePermission(agent, [
            Permission.HOME_DEVICE_DETAILS_READ,
        ]),
        canUpdateHomeDevice: doesAgentHavePermission(agent, [
            Permission.HOME_DEVICE_DETAILS_WRITE,
        ]),
        canCreateHomeDevice: doesAgentHavePermission(agent, [
            Permission.HOME_DEVICE_DETAILS_CREATE,
        ]),
        canRemoveHomeDevice: doesAgentHavePermission(agent, [
            Permission.HOME_DEVICE_DETAILS_DELETE,
        ]),
        canViewHomeMembers: doesAgentHavePermission(agent, [
            Permission.HOME_MEMBERS_LIST_READ,
        ]),
        canAddHomeMember: doesAgentHavePermission(agent, [
            Permission.HOME_MEMBER_DETAILS_CREATE,
        ]),
        canRemoveHomeMember: doesAgentHavePermission(agent, [
            Permission.HOME_MEMBER_DETAILS_DELETE,
        ]),
        canViewHomeKVPair: doesAgentHavePermission(agent, [
            Permission.HOME_KV_PAIR_DETAILS_READ,
        ]),
        canUpdateHomeKVPair: doesAgentHavePermission(agent, [
            Permission.HOME_KV_PAIR_DETAILS_WRITE,
        ]),
        canCreateHomeKVPair: doesAgentHavePermission(agent, [
            Permission.HOME_KV_PAIR_DETAILS_CREATE,
        ]),
        canRemoveHomeKVPair: doesAgentHavePermission(agent, [
            Permission.HOME_KV_PAIR_DETAILS_DELETE,
        ]),
        canViewDeviceKVPair: doesAgentHavePermission(agent, [
            Permission.DEVICE_KV_PAIR_DETAILS_READ,
        ]),
        canUpdateDeviceKVPair: doesAgentHavePermission(agent, [
            Permission.DEVICE_KV_PAIR_DETAILS_WRITE,
        ]),
        canCreateDeviceKVPair: doesAgentHavePermission(agent, [
            Permission.DEVICE_KV_PAIR_DETAILS_CREATE,
        ]),
        canRemoveDeviceKVPair: doesAgentHavePermission(agent, [
            Permission.DEVICE_KV_PAIR_DETAILS_DELETE,
        ]),
        canViewLogs: doesAgentHavePermission(agent, [
            Permission.LOGS_LIST_READ,
        ]),
    };
};
/**
 * An enum representing the types of configurable IAM settings.
 */
export var MCRMTIAMSettingTypes;
(function (MCRMTIAMSettingTypes) {
    MCRMTIAMSettingTypes["CAN_SUDO"] = "canSudo";
    MCRMTIAMSettingTypes["EDIT_AGENTS"] = "canEditAgents";
    MCRMTIAMSettingTypes["EDIT_PROJECTS"] = "canEditProjects";
    MCRMTIAMSettingTypes["EDIT_CUSTOMERS"] = "canEditCustomers";
    MCRMTIAMSettingTypes["EDIT_CONTRACTS"] = "canEditContracts";
    MCRMTIAMSettingTypes["EDIT_BILLING_ACCOUNTS"] = "canEditBillingAccounts";
    MCRMTIAMSettingTypes["EDIT_BILLS"] = "canEditBills";
    MCRMTIAMSettingTypes["EDIT_OPERATORS"] = "canEditOperators";
    MCRMTIAMSettingTypes["EDIT_TASKS"] = "canEditTasks";
})(MCRMTIAMSettingTypes || (MCRMTIAMSettingTypes = {}));
